import { Controller } from '@hotwired/stimulus';
import { FormException, getForm } from '../utilities/form';

export default class extends Controller {
    async handleSubmit(event) {
        const submitButton = event.submitter;
        submitButton.disabled = true;

        event.preventDefault();

        try {
            await getForm(event.target).submit(event);
            if (submitButton.hasAttribute('data-allow-reenable-on-success')) {
                submitButton.disabled = false;
            }
        } catch (e) {
            if (e instanceof FormException && e.isSubmitting) {
                submitButton.disabled = false;
                return;
            }

            submitButton.disabled = false;
        }

        this.resetTurnstile();
    }

    async submitForm(event) {
        event.preventDefault();

        const target = event.params.form;
        const action = event.params.action;
        let extra = event.params.extra || {};

        if (typeof extra === 'string') {
            extra = JSON.parse(extra);
        }

        let formEl = null;

        if (!target || target === 'closest') {
            formEl = event.target.closest('form');
        } else {
            formEl = document.getElementById(target);
        }

        if (!formEl) {
            console.warn('Target form not found', target);
            return;
        }

        try {
            const form = getForm(formEl);

            if (action) {
                form.setUrl(action);
            }

            await form.submit(event, extra, event.currentTarget);
        } catch (e) {
            if (e instanceof FormException) {
                if (e.isSubmitting) {
                    return;
                }

                console.error(e);
            } else {
                console.error(e);
            }
        }
    }

    // CloudFlare
    resetTurnstile() {
        if (typeof window !== 'undefined' &&
            window.turnstile &&
            typeof window.turnstile.reset === 'function') {

            try {
                const turnstileWidgets = document.querySelectorAll('.cf-turnstile');
                if (turnstileWidgets.length > 0) {
                    window.turnstile.reset();
                }
            } catch (error) {}
        }
    }
}
